<template>
  <div>
    <div class="breadlist">
      <bread-list :routeQuery="routeQuery"></bread-list>
    </div>
    <div class="teacher-detail">
      <div class="teacher-top fs-lg d-flex">
        <div class="basic-img">
          <div class="img-div">
            <img :src="getTearcherImg(teacherData.img)" @error="headError" />
          </div>

          <div class="polygon-one"></div>
          <div class="polygon-two"></div>
          <div class="polygon-three"></div>
          <div class="polygon-four"></div>
          <div class="polygon-five"></div>
        </div>
        <div class="basic-info weight">
          <div class="line d-flex">
            <div class="label">姓&nbsp;&nbsp;&nbsp;名：</div>
            {{ teacherData.name }}
          </div>
          <div class="line d-flex" v-if="!!teacherData.gender">
            <div class="label">性&nbsp;&nbsp;&nbsp;别</div>
            {{ teacherData.gender }}
          </div>
          <div class="line d-flex" v-if="!!teacherData.collegeName">
            <div class="label">学&nbsp;&nbsp;&nbsp;院：</div>
            {{ teacherData.collegeName }}
          </div>
          <div class="line d-flex" v-if="!!teacherData.positionalTitles">
            <div class="label">职&nbsp;&nbsp;&nbsp;称：</div>
            {{ teacherData.title }}
          </div>
          <div class="line d-flex" v-if="!!teacherData.email">
            <div class="label">邮&nbsp;&nbsp;&nbsp;箱：</div>
            {{ teacherData.email }}
          </div>
          <div class="line d-flex" v-if="!!teacherData.address">
            <div class="label">办公室：</div>
            {{ teacherData.address }}
          </div>
        </div>
      </div>
      <div style="margin-top: 24px" v-for="(item, index) in lists" :key="index">
        <div class="item d-flex" v-if="!!teacherData.extend[item.feild]">
          <div class="item-logo"></div>
          <div class="item-title weight fs-lg">{{ item.title }}</div>
        </div>
        <!-- <div class="item-content">{{ teacherData.extend[item.feild] }}</div> -->
        <div class="item-content" v-html="teacherData.extend[item.feild]"></div>
      </div>
    </div>
  </div>
</template>
<script>
import BreadList from '../../components/BreadList/index.vue'
import { getTeacherInfo } from '@/api/api'
export default {
  components: {
    BreadList,
  },
  data() {
    return {
      teacherData: {
        name: '',
        sex: '',
        age: '',
        major: '',
        email: '',
        office: '',
        img: '',
        quotes: '',
        workethic: '',
        results: '',
        scientificResearch: '',
        professionalAffiliations: '',
      },
      lists: [
        { feild: 'remark', title: '教师简介' },
        { feild: 'my', title: '名言' },
        { feild: 'workMind', title: '工作理念' },
        { feild: 'workResult', title: '业绩' },
        { feild: 'content', title: '科学研究' },
        { feild: 'societyJob', title: '社会兼职' },
      ],
      routeQuery: '',
      teacherId: '',
    }
  },
  created() {
    this.routeQuery = this.$route.query
    this.teacherId = this.routeQuery.teacherId
    this.getTeacher()
  },
  computed: {
    getTearcherImg() {
      return function (item) {
        if (item == null || item == '') {
          if (this.teacherData.gender == '女') {
            return require('@/assets/img/default2.png')
          } else {
            return require('@/assets/img/default.png')
          }
        } else {
          return item
        }
      }
    },
  },
  methods: {
    headError(e) {
      e.target.src = require('@/assets/img/default.png')
    },
    getTeacher() {
      getTeacherInfo(this.teacherId).then((res) => {
        if (res.data.statusCode == 1) {
          this.teacherData = res.data.obj
          if (this.teacherData.extend.fileInfo != null) {
            this.teacherData.img = res.data.obj.extend.fileInfo.path
          }
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.breadlist {
  width: 1100px;
  margin-left: calc(50% - 550px);
}
.teacher-detail {
  width: 980px;
  padding: 24px 60px;
  margin: 0 auto;
  color: #181818;
}
.basic-img {
  position: relative;
  //   max-width: 225px;
  width: 300px;
  height: 400px;
  //   overflow:hidden;

  .img-div {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.basic-info {
  width: calc(100% - 504px);
  padding: 24px;
  color: #2f2f2f;
  .line {
    width: 100%;
    margin-bottom: 26.5px;
  }
  .label {
    width: 80px;
  }
}
.item-logo {
  width: 4px;
  height: 25px;
  background: #80bca6;
  border-radius: 3px;
}
.item-title {
  line-height: 25px;
  color: #2f2f2f;
  margin-left: 10px;
}
.item-content {
  margin-top: 20px;
  font-size: 15px;
  color: #2f2f2f;
}
.polygon-one {
  //   background: #007a4d;
  //   opacity: 0.2;
  //   transform: matrix(0.98, -0.57, -0.15, 0.89, 0, 0);
  background: url('../../assets/img/Rectangle3.svg') no-repeat;
  position: absolute;
  width: 120px;
  height: 92px;
  top: -18px;
  left: -26px;
}
.polygon-two {
  background: url('../../assets/img/Rectangle1.svg') no-repeat;
  position: absolute;
  width: 108px;
  height: 120px;
  top: 600px;
  left: -170px;
}
.polygon-three {
  background: url('../../assets/img/Rectangle2.svg') no-repeat;
  position: absolute;
  width: 120px;
  height: 105px;
  top: 80px;
  left: 900px;
}
.polygon-four {
  background: url('../../assets/img/Rectangle4.svg') no-repeat;
  position: absolute;
  width: 120px;
  height: 86px;
  top: 180px;
  left: 850px;
}
.polygon-five {
  background: url('../../assets/img/Rectangle5.svg') no-repeat;
  position: absolute;
  width: 72px;
  height: 56px;
  top: 800px;
  left: 1100px;
}
</style>
